<template>
  <div id="content"></div>
</template>

<script>
export default {
  name: "notfound",
  components: {},
  created() {
    this.$router.push("/");
  }
};
</script>

<style lang="scss" scoped></style>
